import styled from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";

import { Modal } from "components/Modal";

export const StyledModal = styled(Modal)<ThemeProps>`
  width: 35rem;
  max-width: 100%;
  border-radius: 1rem;
`;
